// Mesaj listesinin birleştirme kuralları (9.34 · D-621).
//
// İki ayrı kaynak aynı listeye yazıyor: sunucudan çekme (üyeliği O belirler —
// silinen mesaj listeden düşmeli) ve gönderimden sonra yapılan iyimser ekleme.
// İkisi yarışabiliyordu ve sonucu kullanıcı görüyordu:
//
//   1. `send()` POST atar, mesajın kimliğini alır.
//   2. Araya giren yoklama sunucudan çeker. Satır ORADA artık vardır ama düz
//      metni henüz önbellekte yoktur, çünkü önbelleğe kimlik dönmeden yazılamaz.
//      Gönderen kendi mesajını çözemediği için satır "şifreli" kalır.
//   3. `send()` devam edip aynı kimliği listeye EKLER.
//
// Sonuç: aynı mesaj iki balon, biri de "şifreli mesaj" etiketiyle — yani kişi
// kendi yazdığını okunamaz sanır. Kaybolan bir şey yoktu, bir sonraki tam çekme
// düzeltiyordu; ama arada gösterilen şey yalandı.
//
// Kural ayrımı burada: ÜYELİĞİ sunucu belirler, OKUNABİLİRLİĞİ yerel bilgi.
import { Message } from '../services/api';

/**
 * Sunucudan gelen listeyi uygula, ama elimizde ÇÖZÜLMÜŞ kopyası olan satırın
 * metnini koru. Üyelik sunucunundur: burada olmayan mesaj listeden düşer.
 *
 * Neden gerekli: çözme tek seferliktir ve gönderen kendi mesajını hiç çözemez.
 * Sunucunun kopyası her çekmede "şifreli" gelir; yerelde okunur hâli varken onu
 * atmak, okunan bir mesajı okunamaz hâle döndürmek olurdu.
 */
export function mergeFetched(prev: Message[], fetched: Message[]): Message[] {
  const cozulmus = new Map<number, Message>();
  for (const m of prev) if (m.type !== 'encrypted') cozulmus.set(m.id, m);
  return fetched.map((m) => {
    if (m.type !== 'encrypted') return m;
    const bilinen = cozulmus.get(m.id);
    return bilinen ? { ...m, content: bilinen.content, type: bilinen.type } : m;
  });
}

/**
 * Gönderilen mesajı listeye koy. Araya giren bir çekme onu ÇOKTAN eklemiş
 * olabilir, o yüzden ekleme değil YERİNE KOYMA: aynı kimlik iki balon olamaz.
 */
export function upsertLocal(prev: Message[], msg: Message): Message[] {
  const yeri = prev.findIndex((m) => m.id === msg.id);
  if (yeri === -1) return [...prev, msg];
  const kopya = prev.slice();
  kopya[yeri] = msg;
  return kopya;
}
